<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
$(document).ready(function() {

  if(window.location.hash == '#recover'){
    $("html, body").animate({ scrollTop: 100 }, "slow");
  }
  $('.forget-password,.cancel').click(function(){
    $("html, body").animate({ scrollTop: 100 }, "slow");
  });
  
  $("input[name='contact[phone]']").keypress(function(e) {
    var charCode = e.which ? e.which : event.keyCode;
    if (String.fromCharCode(charCode).match(/[^0-9+]/g)) return !1;
  });
  
});
// document.querySelector('.info-item.comment').addEventListener('click', function(e) {
//     e.preventDefault(); 
//     const targetId = this.getAttribute('href').substring(1); 
//     const targetElement = document.getElementById(targetId); 
//     if (targetElement) {
//         const topPosition = targetElement.offsetTop; 
//         window.scrollTo({
//             top: topPosition - 70,
//             behavior: 'smooth' 
//     })}
// });
